import { Divider, Grid, IconButton, Paper, Typography } from "@mui/material";
import React from "react";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import { useForm } from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import { WSIcons } from "../../commonFunctions/iIcons";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import Firm from "./EditFirm";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import { useNavigate } from "react-router-dom";
import config from "../../Config/clientConfig.json"
export const General: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset, watch } = useForm();
  // Watch the deliveryChallan checkbox
  const deliveryChallanChecked = watch("deliveryChallan", false);
  const navigate = useNavigate();

  const handleClick = () => {
        openPopUp(metadata, handleData, "60rem");
      };
        const handleData = async (data: any) => {
        debugger;
        console.log("onsubmit===>", data); // You can perform any action with the submitted data here
      };

   const metadata: IMetaData = {
        title: "Edit Firm",
        hideActions: false,
        content: (props: any, row: any) => (
            <Firm {...props} />
        ),
        actions: [
            {
                label: "Cancel",
                // onClick: handleCloseDialog,
                className: "ws-cancel",
                type: "button",
            },
            {
                label: "Save",
                type: "submit",
            onClick: handleData,
                autoFocus: true,
            },
        ],
        isDragable: true,
    };

     const handleCancelClick = () => {
    navigate("/");
  };
  return (
    <Grid p={2}>
      <Paper sx={{ padding: 3,position: "relative" }} elevation={0}>
          {/* Close Icon in top right */}
  <IconButton
    size="small"
    sx={{ position: "absolute", top: 8, right: 8 }}
    onClick={handleCancelClick} // replace with your close logic
  >
    <WSIcons.CloseIcon fontSize="small" />
  </IconButton>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>Application</Typography>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Enable Passcode"
                  id="enablePasscode"
                  control={control}
                  {...register("enablePasscode")}
                  rules={{ required: false }}
                  name="enablePasscode"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSelectField
                  rules={{ required: true }}
                  control={control}
                  id="businessCurrency"
                  {...register("businessCurrency")}
                  name="businessCurrency"
                  label="Business Currency"
                  options={config.businessCurrencyConfig.staticOptionData}
                />
              </Grid>
              <Grid item xs={12}>
                <WSTextField
                  label={"Amount"}
                  {...register("amount")}
                  id="amount"
                  name="amount"
                  control={control}
                  rules={{ required: true }}
                  type={TextType.Number}
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="GSTIN Number"
                  id="gstNumber"
                  control={control}
                  {...register("gstNumber")}
                  rules={{ required: false }}
                  name="gstNumber"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Stop Sale On Negative Stock"
                  id="stopSaleonNegativeStock"
                  control={control}
                  {...register("stopSaleonNegativeStock")}
                  rules={{ required: false }}
                  name="stopSaleonNegativeStock"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Block New Items From Txn Form"
                  id="blockNewItemsFromTxnForm"
                  control={control}
                  {...register("blockNewItemsFromTxnForm")}
                  rules={{ required: false }}
                  name="blockNewItemsFromTxnForm"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Block New Parties From Txn Form"
                  id="blockNewPartiesFromTxnForm"
                  control={control}
                  {...register("blockNewPartiesFromTxnForm")}
                  rules={{ required: false }}
                  name="blockNewPartiesFromTxnForm"
                />
              </Grid>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>More Transactions</Typography>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Estimate/Quatation"
                  id="estimateQuatation"
                  control={control}
                  {...register("estimateQuatation")}
                  rules={{ required: false }}
                  name="estimateQuatation"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Proforma Invoice"
                  id="proformaInvoice"
                  control={control}
                  {...register("proformaInvoice")}
                  rules={{ required: false }}
                  name="proformaInvoice"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Sale/Purchase Order"
                  id="sale"
                  control={control}
                  {...register("sale")}
                  rules={{ required: false }}
                  name="sale"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Other Income"
                  id="otherIncome"
                  control={control}
                  {...register("otherIncome")}
                  rules={{ required: false }}
                  name="otherIncome"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Fixed Assets(FA)"
                  id="fixedAssets"
                  control={control}
                  {...register("fixedAssets")}
                  rules={{ required: false }}
                  name="fixedAssets"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Delivery Challan"
                  id="deliveryChallan"
                  control={control}
                  {...register("deliveryChallan")}
                  rules={{ required: false }}
                  name="deliveryChallan"
                />
              </Grid>
              {deliveryChallanChecked && (
                <>
                  <Grid item xs={12}>
                    <WSSCheckBoxField
                      label="Goods Return On Delivery Challan"
                      id="goodsReturnOnDeliveryChallan"
                      control={control}
                      {...register("goodsReturnOnDeliveryChallan")}
                      rules={{ required: false }}
                      name="goodsReturnOnDeliveryChallan"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <WSSCheckBoxField
                      label="Print Amount In Delivery Challan"
                      id="printAmountInDeliveryChallan"
                      control={control}
                      {...register("printAmountInDeliveryChallan")}
                      rules={{ required: false }}
                      name="printAmountInDeliveryChallan"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>Multi Firm</Typography>

                <Divider />
              </Grid>
              <Grid item xs={12}>
                <Paper
                  elevation={0}
                  sx={{
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: 250, // you can adjust
                  }}
                >
                  {/* Left Side - Company Name */}
                  <Typography>My Company</Typography>

                  {/* Right Side - Pen Icon */}
                  <IconButton size="small" color="primary">
                    <span style={{ fontSize: "small" }}>Default</span>{" "}
                    <WSIcons.Edit fontSize="small" onClick={handleClick}/>
                  </IconButton>
                </Paper>{" "}
              </Grid>
              <Grid item xs={12} mt={38}>
                <Typography fontWeight={"bold"}>
                  Stock Transfer Between Godowns
                </Typography>

                <Divider sx={{ mt: 1 }} />
              </Grid>
              <Grid item xs={12}>
            <Typography sx={{fontSize:"small"}}>Manage all your stores/godowns and transfer stock seamlessly
                between them. Using this feature, you can transfer stock between
                stores/godowns and manage your inventory more efficiently.</Typography> 
              </Grid>
              <Grid item xs={12}>
                    <WSSCheckBoxField
                      label="Godown Management & Stock Transfer"
                      id="godownManagement"
                      control={control}
                      {...register("godownManagement")}
                      rules={{ required: false }}
                      name="godownManagement"
                    />
                  </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={2}>
                 <Grid item xs={12}>
                <Typography fontWeight={"bold"}>Backup & History</Typography>

                <Divider />
              </Grid>
                  <Grid item xs={12}>
                    <WSSCheckBoxField
                      label="Auto Backup"
                      id="autoBackup"
                      control={control}
                      {...register("autoBackup")}
                      rules={{ required: false }}
                      name="autoBackup"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <WSSCheckBoxField
                      label="Audit Trail"
                      id="auditTrail"
                      control={control}
                      {...register("auditTrail")}
                      rules={{ required: false }}
                      name="auditTrail"
                    />
                  </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
});
